import { render } from "./add-edit-modal.html?vue&type=template&id=4a1677a8&scoped=true&ts=true&external"
import script from "./add-edit-modal.ts?vue&type=script&lang=ts&external"
export * from "./add-edit-modal.ts?vue&type=script&lang=ts&external"

import "./add-edit-modal.scss?vue&type=style&index=0&id=4a1677a8&scoped=true&lang=sccs&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a1677a8"]])

export default __exports__